import Nav from "./Nav";
import "./Project.css";
import "../App.css";
import React, { useEffect, useState } from "react";
import { createApi } from "unsplash-js";
import pageTransition from "../transition";
import { AnimatePresence, motion } from "framer-motion";
import Typewriter from "typewriter-effect";



const unsplash = createApi({
    accessKey: 'iSmGmN6DeYNGz2dXLdqG_C_JfhdzdYya0VdtMQwxlEA',
});



const exifList = [
    {
        name: "Focal Length",
        keyName: "focal_length",
        unit: "mm",
    },
    {
        name: "Aperture",
        keyName: "aperture",
        unit: "ƒ",
    },
    {
        name: "ISO",
        keyName: "iso",
        unit: "",
    },
    {
        name: "Shutter Speed",
        keyName: "exposure_time",
        unit: "s",
    }
]



const Gallery = () => {
    document.title = "Xinyi | Gallery";
    const [photoID, setPhoto] = useState(0);
    const [photo_list, setPhotoList] = useState([{}]);
    const [photoInfo, setInfo] = useState({})
    const [fetchingList, setList] = useState(true); // Add loading list state
    const [fetchingPhoto, setFetch] = useState(true); // Add loading photo state

    useEffect(() => {
        // Fetch photo_list
        // unsplash.users
        //   .getPhotos({ username: 'ewxy'})
        unsplash.collections
            .getPhotos({ collectionId: 'ysb-Oe2qLJc', perPage: 25 })
            .then((result) => {
                setPhotoList(result.response.results);
            })
            .catch(() => {
                console.log('Fetch photo list went wrong!');
            })
            .finally(() => {
                setList(false); // Mark loading as false once API call is done
            });
    }, []); // Empty dependency array ensures the effect runs only once after the initial render

    useEffect(() => {
        // Fetch data and update photo_list
        if (!fetchingList && photo_list.length > 0) { // Check if loading is false and photo_list is not empty
            unsplash.photos.get({ photoId: photo_list[photoID].id })
                .then((result) => {
                    setInfo(result.response);
                })
                .catch(() => {
                    console.log('Fetch photo data went wrong!');
                })
                .finally(() => {
                    setFetch(false); // Mark loading as false once API call is done
                });
        }
    }, [fetchingList, photo_list, photoID]);


    // Slide Function
    function switchRight() {
        setPhoto((photoID + 1) % photo_list.length);
    }

    function switchLeft() {
        setPhoto((photoID - 1 + photo_list.length) % photo_list.length);
    }

    // Keyboard Event
    document.addEventListener("keydown", (event) => {
        if (event.key === 'ArrowRight') {
            switchRight();
        }
        if (event.key === 'ArrowLeft') {
            switchLeft();
        }
    })

    // Animation
    const imageVars = {
        // initial: {
        //     opacity: 0,
        // },
        // animate: {
        //     opacity: 1,
        //     transition: {
        //         duration: 0.5,
        //     }
        // },
        // exit: {
        //     opacity: 0,
        //     transition: {
        //         duration: 0.5,
        //     }
        // }
    }

    const textVars = {
        hidden: {
            transition: {
                staggerChildren: 0.09,
                staggerDirection: -1,
            }
        },
        show: {
            transition: {
                delayChildren: 0.3,
                staggerChildren: 0.09,
                staggerDirection: 1,
            }
        }
    }


    const textItemVars = {
        hidden: {
            y: "30vh",
            transition: {
                duration: 0.5,
                ease: [0.37, 0, 0.63, 1]
            }
        },
        show: {
            y: 0,
            transition: {
                duration: 0.7,
                ease: [0, 0.55, 0.45, 1]
            }
        }
    }


    return (
        <>

            {fetchingPhoto ? ( // Show loading indicator if still loading
                <>
                    {Nav("gallery")}
                    <Typewriter
                        className="loading"
                        options={{
                            loop: true,
                        }}
                        onInit={(typewriter) => {
                            typewriter
                                .typeString("Loading...")
                                .pauseFor(2000)
                                .start();
                        }}
                    />
                </>
            ) : (
                <div>
                    {Nav("gallery", photoInfo.color)}
                    <div className="project" key={photoID}> {/* Adding a key to remount for animation. */}
                        <div className="img">
                            <AnimatePresence>
                                <motion.img src={photo_list[photoID].urls['regular']}
                                    key={photoID}
                                    alt={photo_list[photoID].alt_description}
                                    className="photo"
                                    id={photoInfo.width > photoInfo.height ? "landscape" : "portrait"}
                                    variants={imageVars}
                                    initial="initial"
                                    animate="animate"
                                    exit="exit"
                                />
                            </AnimatePresence>
                        </div>
                        <motion.div className="photo-description"
                            variants={textVars}
                            initial="hidden"
                            animate="show"
                            exit="hidden">
                            <motion.div className="description"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}>
                                {photoInfo.description}
                            </motion.div>

                            <div className="EXIF">
                                {
                                    exifList.map((item) => {
                                        return (
                                            <div className="overflow-hidden">
                                                <motion.p variants={textItemVars}>{item.name}: {photoInfo.exif[item.keyName]}{item.unit}</motion.p>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </motion.div>
                    </div>


                    <div className="switch-container" id="gallery-switch">
                        <div className="switch-button" onClick={switchLeft} id="left">
                            <p className="icon">&lt;</p>
                        </div>
                        <div className="switch-button" onClick={switchRight} id="right">
                            <p className="icon">&gt;</p>
                        </div>
                    </div>
                </div>)
            }
        </>
    );
};

export default pageTransition(Gallery);